<section id="signin" style="background-image: url(../assets/images/signin_01.jpg); height: 100%; background-position: center;
    background-repeat: no-repeat; background-size: cover; overflow: hidden;">
    <div class="container d-flex flex-column">
        <div class="row align-items-center justify-content-center g-0 min-vh-100">
            <div class="col-8 col-sm-8 col-md-5 col-xxl-4 py-8 py-xl-0">
                <!-- Card -->
                <div class="card shadow p-3 mb-5 rounded-3 animate__animated animate__fadeInUp">
                    <!-- Card body -->
                    <div class="card-body p-6">
                        <div class="mb-4">
                            <img src="../../assets/images/mcrb_blue.png" class="mb-2" alt="metropol corporation logo"
                                style="width: 12rem;">
                            <p class="mb-6" style="color: #6c757d; margin-top: .5rem; margin-bottom: 3rem;">
                                Login to manalytics uganda
                            </p>
                        </div>
                        <!-- Form -->
                        <form autocomplete="off" [formGroup]="signinForm" (ngSubmit)="signin(signinForm.value)">
                            <!-- Username -->
                            <div class="mb-3">
                                <label for="email" class="form-label">Email address</label>
                                <input type="email" id="email" class="form-control" formControlName="email" name="email"
                                    [class.is-invalid]="isEmailInvalid || isEmailPatternInvalid || isEmailLengthInvalid"
                                    placeholder="Enter email address">
                                <!-- error messsage -->
                                <small class="form-text text-danger"
                                    *ngIf="isEmailInvalid || isEmailPatternInvalid || isEmailLengthInvalid">
                                    <div *ngIf="isEmailInvalid">An email address is required</div>
                                    <div *ngIf="isEmailPatternInvalid">Provide a valid email address</div>
                                    <div *ngIf="isEmailLengthInvalid">
                                        An email address with a maximum of 50 characters is accepted
                                    </div>
                                </small>
                            </div>
                            <!-- Password -->
                            <div class="mb-3">
                                <label for="password" class="form-label">Password</label>
                                <input type="password" id="password" class="form-control" formControlName="password"
                                    name="password"
                                    [class.is-invalid]="isPasswordPatternInvalid || isPasswordInvalid || isPasswordLengthInvalid"
                                    placeholder="Enter password">
                                <!-- error messsage -->
                                <small class="form-text text-danger"
                                    *ngIf="isPasswordInvalid || isPasswordPatternInvalid || isPasswordLengthInvalid">
                                    <div *ngIf="isPasswordInvalid">A password is required</div>
                                    <div *ngIf="isPasswordPatternInvalid">
                                        A valid password with a minimum of 8 characters is required
                                    </div>
                                    <div *ngIf="isPasswordLengthInvalid">
                                        A password with a maximum of 50 characters is accepted
                                    </div>
                                </small>
                            </div>
                            <div>
                                <!-- Button -->
                                <div class="d-grid">
                                    <button type="submit" class="btn btn-primary mt-2"
                                        [disabled]="signinForm.invalid || isLoading">
                                        Sign In
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                                            aria-hidden="true"></span>
                                    </button>
                                </div>

                                <div class="d-md-flex justify-content-between mt-4">
                                    <div>
                                        <a routerLink="/credentials/forgot" class="text-inherit">Forgot your
                                            password?</a>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>